// Response-envelope helper for the Service Desk service layer.
//
// The torre-de-control-api wraps every payload in `{ meta, data }`, and the
// serviceDesk controller additionally nests its handler payload as
// `{ message, data }` — so the real payload lives at `res.data.data.data`.
// Older/alternate shapes (pageResponse, or a future backend) expose it at
// `res.data.data`. `unwrap` reads the deep level first and falls back, so the
// client works against either backend shape (deployed dev vs. local emulator).
//
// Kept dependency-free (no axios/firebase imports) so it is unit-testable in
// isolation — see serviceDeskService.unwrap.test.ts.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const unwrap = (res: any): any => res?.data?.data?.data ?? res?.data?.data;
